import {
    addNewRowToTable,
    convertCurrencyFormatPositiveNegative, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridFourColumn,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    showErrorMessage,
    RaikoTableTitleContainer
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {AccountService} from "../../serverService/account/AccountService";
import {useAuthState} from "../../context/AuthContext";
import {addFiltersToUrl} from "../../util/FiltersHelper";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import NewAccount from "./newAccount/NewAccount";
import {stringIsEmpty} from "../../util/VariableChecker";

export default function AccountsList() {

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1);
    const size = 20

    const navigate = useNavigate()

    const [fullName, setFullName] = useState(searchParam.get("name") || "")
    const [nationalCode, setNationalCode] = useState(searchParam.get("national-code") || "");
    const [groupName, setGroupName] = useState(searchParam.get("group-name") || "");
    const [accountCode, setAccountCode] = useState(searchParam.get("account-code") || "");

    const filterFullName = useDebounce(fullName, 300)
    const filterNationalCode = useDebounce(nationalCode, 300)
    const filterGroupName = useDebounce(groupName, 300)
    const filterAccountCode = useDebounce(accountCode, 300)

    const [tableLoading, setTableLoading] = useState(true)
    const [accountsItems, setAccountsItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const service = new AccountService()

    const {fundID} = useAuthState()

    useEffect(() => {
        if (
            typeof filterGroupName !== "undefined" &&
            typeof filterFullName !== 'undefined' &&
            typeof filterNationalCode !== 'undefined' &&
            typeof filterAccountCode !== 'undefined'
        ) {
            getDataFromServer()
            prepareFiltersParam()
        }
    }, [
        filterGroupName,
        filterFullName,
        filterNationalCode,
        filterAccountCode,
        page,
        fundID
    ]);

    function prepareFiltersParam() {
        const filters = []

        if (page && page > 1)
            filters.push(`page=${page}`)

        if (!stringIsEmpty(filterGroupName))
            filters.push(`group-name=${filterGroupName}`)

        if (fullName && fullName.length > 0)
            filters.push(`name=${fullName}`)

        if (nationalCode && nationalCode.length > 0)
            filters.push(`national-code=${nationalCode}`)

        if (accountCode && accountCode.length > 0)
            filters.push(`account-code=${accountCode}`)

        navigate(addFiltersToUrl(filters))
    }

    function prepareItem(id, number, accountCode, firstname, lastname, nationalCode, groupName, balance, enabled, cleared) {

        return {
            id,
            number,
            name: `${firstname} ${lastname}`,
            nationalCode: nationalCode ? nationalCode : '-',
            accountCode,
            group: groupName ? groupName : '-',
            capacity: convertCurrencyFormatPositiveNegative(balance),
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={!cleared}
                deActiveStateTitle={"بسته شده"}
                activeStateTitle={"فعال"}
            />
        }
    }

    function getDataFromServer() {
        setTableLoading(true)

        service.getAccounts(
            page > 0 ? page - 1 : 0,
            size,
            fundID,
            filterGroupName,
            filterFullName,
            filterNationalCode,
            filterAccountCode
        ).then(response => {

            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setAccountsItems([])
            response.data.map((item, index) => {
                setAccountsItems(prev => [
                    ...prev,
                    prepareItem(
                        item.id,
                        (page * size) + index + 1,
                        item.number,
                        item.ownerFirstName,
                        item.ownerLastName,
                        item.ownerNationalCode,
                        item.OwnerGroupName,
                        item.balance,
                        item.enabled,
                        item.cleared
                    )
                ])
            })
        }).catch(reason => {
            showErrorMessage((detectServerErrorMessage(reason)))
        }).finally(_ => {
            setTableLoading(false)
        })

    }


    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    const [openDialogState, setOpenDialogState] = useState(false)
    const handleOpenDialog = () => setOpenDialogState(true)
    const handleCloseDialog = () => setOpenDialogState(false)

    function handleAddNewAccountToTable(newItem) {
        setTableLoading(true)
        const accounts = addNewRowToTable(
            prepareItem(
                newItem.id,
                (page * size) + 1,
                newItem.number,
                newItem.ownerFirstName,
                newItem.ownerLastName,
                newItem.ownerNationalCode,
                newItem.OwnerGroupName,
                newItem.balance,
                newItem.enabled,
                false
            ),
            accountsItems
        )

        setAccountsItems(accounts)
        handleCloseDialog()
        setTableLoading(false)
    }


    function handleShowDetail(id) {
        let title = ""
        accountsItems.map((item) => {
            if (item.id === id)
                title = item.name
        })

        navigate(
            RouteHelper.AccountsDetail.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialogState}
                pageTitle={"افتتاح حساب"}
                dialogSize={DialogSize.LARGE}
            >
                <NewAccount
                    handleAddNewAccountToTable={handleAddNewAccountToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.AccountsList.name,
                            RouteHelper.AccountsList.globalUrl
                        )
                    ]}/>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridFourColumn>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام و نام خانوادگی"}
                                    value={fullName}
                                    setValue={setFullName}/>

                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    value={nationalCode}
                                    setValue={setNationalCode}/>

                                <RaikoMaterialOutlinedInput
                                    labelText={"گروه"}
                                    setValue={setGroupName}
                                    value={groupName}/>

                                <RaikoNumberInputOutlined
                                    labelText={"شماره حساب"}
                                    setValue={setAccountCode}
                                    value={accountCode}/>

                            </RaikoGridFourColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"حساب ها"}
                                amount={totalItems}
                                hasCreateNewItem
                                createNewItemTitle={"افتتاح حساب"}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={header}
                                data={accountsItems}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                newPage={page}
                                handlePaginationChange={handleChangePagination}
                                rowClicked={handleShowDetail}

                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'accountCode',
        label: 'شماره حساب',
        align: 'right',
    },
    {
        id: 'group',
        label: 'گروه',
        align: 'right',
    },
    {
        id: 'capacity',
        label: 'موجودی(ریال)',
        align: 'right',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
        align: 'right',
    },

]
